import { render, staticRenderFns } from "./muestraDetalle.vue?vue&type=template&id=4dfc8982"
import script from "./muestraDetalle.vue?vue&type=script&lang=js"
export * from "./muestraDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports